/**
 * 页面背景水印
 * @param {*} param0
 */

export default ({
  width = 210,
  height = 260,
  content,
  rotate = '-10',
} = {}) => {
  const canvas = document.createElement('canvas');
  canvas.setAttribute('width', `${width}px`);
  canvas.setAttribute('height', `${height}px`);
  const ctx = canvas.getContext('2d');
  if (ctx === null) return console.error('this browser is not support canvas.');
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.font = '20pt Calibri';
  ctx.fillStyle = '#e5e5e5';
  ctx.rotate(Math.PI / 180 * rotate);
  ctx.fillText(content, parseFloat(width) / 3, parseFloat(height) / 2);
  const base64Url = canvas.toDataURL();
  const __wm = document.querySelector('.water-mark');
  const watermarkDiv = __wm || document.createElement('div');
  const htmlHidth = document.documentElement.clientHeight || document.body.clientHeight;
  const styleStr = `
            min-height: ${htmlHidth - 20}px;
            background-repeat:repeat;
            position: absolute;
            background-size: ${width / 2}px ${height / 2}px;
            background-clip: content-box;
            background-image:url('${base64Url}')`;
  watermarkDiv.setAttribute('style', styleStr);
  watermarkDiv.classList.add('water-mark');
};